(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7015],{

/***/ 20886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _params_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/components-pages/propiedad/album-section/index.tsx + 6 modules
var album_section = __webpack_require__(648);
// EXTERNAL MODULE: ./shared/components-pages/propiedad/DetailsSection.tsx + 3 modules
var DetailsSection = __webpack_require__(95385);
// EXTERNAL MODULE: ./shared/components-pages/propiedad/LoanCalculatorDetails.tsx + 1 modules
var LoanCalculatorDetails = __webpack_require__(4332);
// EXTERNAL MODULE: ./shared/components-pages/proyectos/PropertiesSlider.tsx
var PropertiesSlider = __webpack_require__(42979);
// EXTERNAL MODULE: ./shared/components/loading-bubbles/index.tsx
var loading_bubbles = __webpack_require__(47364);
// EXTERNAL MODULE: ./api/realestate.request.ts + 1 modules
var realestate_request = __webpack_require__(13897);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./store/property-detail/index.tsx
var property_detail = __webpack_require__(78595);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/news/baners.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




function Banners() {
  var router = (0,next_router.useRouter)(); // const hasReferer = router.asPath.includes("areferer") || router.asPath.includes("referer") 

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null) // <ContentBanner>
  //   <div className="b"></div>
  //   <div className="w"></div>
  //   <a
  //     href={
  //       hasReferer
  //         ? undefined
  //         : "https://hazlatuya.remaxrd.com/?utm_source=paginaremax&utm_medium=banner&utm_campaign=Remaxrd"
  //     }
  //   >
  //     <img
  //       src={
  //         hasReferer
  //           ? "/images/news/banner_feria-4-sin-botton.png"
  //           : "/images/news/banner_feria-4.png"
  //       }
  //     />
  //   </a>
  // </ContentBanner>
  ;
}

/* harmony default export */ var baners = (Banners);

var ContentBanner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ckv2px0"
} : 0)( true ? {
  name: "web1ls",
  styles: "display:flex;width:100%;height:4rem;&>div{width:50%;height:4rem;}.b{background-color:#13408d;}.w{background-color:white;}a{position:absolute;z-index:1;width:100%;height:4rem;}img{object-fit:contain;width:100%;height:4rem;}@media (max-width: 768px){display:flex;width:100%;height:auto;&>div{width:50%;height:auto;}a{position:absolute;z-index:1;width:100%;height:auto;}img{object-fit:contain;width:100%;height:auto;}}"
} : 0);
// EXTERNAL MODULE: ./shared/models/functions/removeparams.ts
var removeparams = __webpack_require__(57626);
// EXTERNAL MODULE: ./shared/components-pages/propiedad/context/DetailPropertyContext.tsx + 1 modules
var DetailPropertyContext = __webpack_require__(74343);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
;// CONCATENATED MODULE: ./pages/propiedad/[...params].tsx


















var Propiedad = function Propiedad(props) {
  var _props$data, _props$data3, _data$slug;

  var translation = (0,next_intl_cjs_production_min.useTranslations)("property");
  var similarProperties = translation("similarProperties") || "";

  var _similarProperties$sp = similarProperties.split(" "),
      _similarProperties$sp2 = (0,toArray/* default */.Z)(_similarProperties$sp),
      title = _similarProperties$sp2[0],
      rest = _similarProperties$sp2.slice(1);

  var _usePropertyDetail = (0,property_detail/* usePropertyDetail */.qd)(),
      setDetailPropertyAction = _usePropertyDetail.setDetailPropertyAction;

  var data = props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.data;
  (0,react.useEffect)(function () {
    var _props$data2;

    if ((props === null || props === void 0 ? void 0 : (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.data) != undefined) {
      // if (props?.reload){
      //   window.location.replace(props?.url?.replaceAll("&mobile=true", "")) ;
      // }
      setDetailPropertyAction(data);
    }
  }, [data]);
  (0,react.useEffect)(function () {
    if (props.id) {
      setTimeout(function () {
        (0,realestate_request/* getRealestateLog */.t5)(props.id);
      }, 1000);
    }
  }, []);

  if ((props === null || props === void 0 ? void 0 : props.data) == undefined || (props === null || props === void 0 ? void 0 : (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.data) == undefined) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(loading_bubbles/* default */.Z, {
      message: "Cargando"
    });
  }

  var metaData = {
    title: (data.realstate_type + " " + data.sector + "-" + props.id).substr(0, 60),
    description: "".concat(data.description ? data.description.replace(/(<([^>]+)>)/gi, "").substr(0, 150) : typeof (data === null || data === void 0 ? void 0 : data.slug) == "number" ? data === null || data === void 0 ? void 0 : data.slug : data === null || data === void 0 ? void 0 : (_data$slug = data.slug) === null || _data$slug === void 0 ? void 0 : _data$slug.replaceAll("-", " "), " ").concat(data.id),
    url: props.url,
    realstateType: data.realstate_type,
    picture: data.pictures[0].pictures
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, metaData.title), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "description",
    content: metaData.description
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:url",
    content: metaData.url
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:type",
    content: metaData.realstateType
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:title",
    content: metaData.title
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:description",
    content: metaData.description
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:image",
    content: metaData.picture
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "robots",
    content: "noindex"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "canonical",
    href: (0,removeparams/* default */.Z)(metaData.url),
    key: "canonical"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "robots",
    content: "noindex"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(DetailPropertyContext/* DetailPropertyProvider */.n, {
    data: data,
    url: props.url
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      backgroundColor: "var(--color-brand-bg-main)"
    },
    marginTop: {
      xs: 0,
      md: 10
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(baners, null), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(album_section/* default */.Z, {
    data: data,
    id: props.id,
    isCollection: false
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(DetailsSection/* default */.Z, {
    data: data,
    realestateId: props.id
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LoanCalculatorDetails/* default */.Z, {
    data: data
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(PropertiesSlider/* default */.Z, {
    title: title,
    subtitle: rest.join(" "),
    filters: {
      similarCode: data === null || data === void 0 ? void 0 : data.id
    },
    refRequest: "property-list-alike-query",
    detailPath: pages_path/* CPagesPath.es.property_detail */.K.es.property_detail
  }))));
};

var __N_SSP = true;
/* harmony default export */ var _params_ = (Propiedad);

/***/ }),

/***/ 20518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76083);
/* harmony import */ var _mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47111);
/* harmony import */ var custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44231);
/* harmony import */ var _slick_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84256);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11496);


var _templateObject;










function CustomCarrusel(props) {
  var _props$colorArrow, _props$colorArrow2, _props$children, _props$numberOfPlaceh;

  var width = (0,custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__/* .useWidth */ .z)();
  var rows = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  };
  var arrowsLeft =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow = props.colorArrow) !== null && _props$colorArrow !== void 0 ? _props$colorArrow : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;left:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){left:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var arrowsRight =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow2 = props.colorArrow) !== null && _props$colorArrow2 !== void 0 ? _props$colorArrow2 : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;right:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){right:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var settings = {
    dots: false,
    infinite: ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.length) > rows[width],
    speed: 500,
    slidesToShow: rows[width],
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      css: arrowsRight
    }),
    prevArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      css: arrowsLeft
    }),
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }]
  };
  var fakeElements = Array.from({
    length: (_props$numberOfPlaceh = props.numberOfPlaceholderItems) !== null && _props$numberOfPlaceh !== void 0 ? _props$numberOfPlaceh : 5
  }, function (v, i) {
    return i;
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(CarruselContainer, {
    container: true,
    justifyContent: "center"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
    item: true,
    xs: 11,
    sm: 11,
    md: 11,
    lg: 10,
    xl: 10,
    my: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_slick_slider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, settings, !(props !== null && props !== void 0 && props.children) && props.enablePlaceholder && fakeElements.map(function (e, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.placeholderItem, {
      key: i
    });
  }), (props === null || props === void 0 ? void 0 : props.children) && props.children)));
}

/* harmony default export */ __webpack_exports__["Z"] = (CustomCarrusel);
var CarruselContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  position: relative;\n  margin: 5px 0px;\n  \n  & .slick-slider {\n  \n    position: relative;\n  }\n  \n  & .slick-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    \n    &:before {\n      display: none;\n    }\n  }\n  \n  & .slick-prev {\n    left: -40px;\n    \n    @media (max-width: 900px) {\n      left: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      left: -10px;\n    }\n  }\n  \n  & .slick-next {\n    right: -40px;\n    \n    @media (max-width: 900px) {\n      right: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      right: -10px;\n    }\n  }\n  \n  & .slick-list {\n    overflow: hidden;\n  }\n  \n  & .slick-track {\n    display: flex;\n    align-items: stretch;\n  }\n  \n  & .slick-slide {\n    > div {\n      height: 100%;\n    }\n  }\n"])));

/***/ }),

/***/ 84256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);

 // Import css files





function SlickSlider(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_slick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, props);
}

/* harmony default export */ __webpack_exports__["Z"] = (SlickSlider);

/***/ }),

/***/ 65402:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/propiedad/[...params]",
      function () {
        return __webpack_require__(20886);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4396,8584,8360,2966,6869,1036,670,7927,8654,9470,2737,5702,3950,9774,2888,179], function() { return __webpack_exec__(65402); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);